import React from 'react';

import PropTypes from 'prop-types';

import { Box, Card, CardContent, Typography } from '@mui/material';

import { COLORS } from '../../../Constant/COLORS';
import { TypoPoppins } from '../../../Components/Typo';

/**
 *
 * @param {{actions?:JSX.Element,data:{place:string,name:string,jobId:string,date:string,note:string,referenceId:string,package:{name:string,price:number}}}} props
 * @returns JSX.Element
 */

function CustomCard({ data, actions }) {
  return (
    <Card sx={{ bgcolor: COLORS.surface, borderRadius: 3 }}>
      <CardContent>
        <Box
          display='grid'
          gap={2}
          alignItems='center'
          gridTemplateAreas={{
            xs: "'name .' 'data data' 'actions actions'",
            md: "'name actions' 'data data'",
          }}>
          <Typography gridArea='name' variant='h5' color={COLORS.teal}>
            {data.name}
          </Typography>

          <Box gridArea='actions'>{actions}</Box>

          <Box
            gridArea='data'
            display='grid'
            gridTemplateColumns={{ xs: 'auto', sm: 'auto 1fr' }}
            columnGap={2}
            rowGap={1}>
            <TypoPoppins color={COLORS.inkSoft}>Reference ID</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.referenceId}</TypoPoppins>

            <TypoPoppins color={COLORS.inkSoft}>Job ID</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.jobId}</TypoPoppins>

            <TypoPoppins color={COLORS.inkSoft}>Service Place</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.place}</TypoPoppins>

            <TypoPoppins color={COLORS.inkSoft}>Event Date</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.date}</TypoPoppins>

            <TypoPoppins color={COLORS.inkSoft}>Note</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.note}</TypoPoppins>

            <TypoPoppins color={COLORS.inkSoft}>Package</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.package.name}</TypoPoppins>

            <TypoPoppins color={COLORS.inkSoft}>Price</TypoPoppins>
            <TypoPoppins fontWeight={500}>{data.package.price}</TypoPoppins>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

CustomCard.propTypes = {
  actions: PropTypes.element,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    jobId: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    place: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    referenceId: PropTypes.string.isRequired,
    package: PropTypes.shape({
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

export default CustomCard;
